import React, { useState } from "react";
import serviceWorldNewCaseStyle from "./serviceWorldNewCaseStyle";
import ServiceWorldContentBox from "./ServiceWorldContentBox";
import IconDocument from "../../assets/icons/generic/IconDocument";
import { Box, Divider, List, ListItem, ListItemButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import { getProductData, productCategoryData } from "../../services/productService";
import DialogModal from "../DialogModal/DialogModal";
import { InfoOutlined } from "@mui/icons-material";
import IconWrapper from "../IconWrapper/IconWrapper";

const ServiceWorldNewCase = () => {
  const [legalExpenseInsuranceModalOpen, setLegalExpenseInsuranceModalOpen] = useState(false);
  return (
    <Box sx={serviceWorldNewCaseStyle.newCaseContainer}>
      <ServiceWorldContentBox headline={"Neuen Fall anlegen"} icon={IconDocument}>
        <List sx={serviceWorldNewCaseStyle.bottomPadding}>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Familienrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} component={Link} to={"/servicewelt/familienrecht/scheidung"}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("divorce", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Scheidung"} />
              </Grid>
              <Grid>Scheidung</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("familyLawCase", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Erstberatung"} />
              </Grid>
              <Grid>Erstberatung Familienrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("alimony", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Unterhalt"} />
              </Grid>
              <Grid>Erstberatung Unterhalt</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("death", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Erbrecht"} />
              </Grid>
              <Grid>Erstberatung Erbrecht/Todesfall</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Verkehrsrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} component={Link} to={"/servicewelt/verkehrsrecht/ordnungswidrigkeit"}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("traffic", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Verkehr"} />
              </Grid>
              <Grid>Ordnungswidrigkeit</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} component={Link} to={"/servicewelt/verkehrsrecht/verkehrsunfall"}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("trafficAccident", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Verkehrsunfall"} />
              </Grid>
              <Grid>Verkehrsunfall</Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Arbeitsrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("employmentContract", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Arbeit"} />
              </Grid>
              <Grid>Beratung / Vertretung Arbeitsrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} component={Link} to={"/servicewelt/arbeitsrecht/kuendigung"}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={getProductData("settlement", "productIcon")} sx={serviceWorldNewCaseStyle.icon} alt={"Abfindung"} />
              </Grid>
              <Grid>Kündigungsschutzklage</Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Vertragsrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={productCategoryData.contractLaw.icon} sx={serviceWorldNewCaseStyle.icon} alt={"Vertragsrecht"} />
              </Grid>
              <Grid>Beratung / Vertretung Vertragsrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Mietrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={productCategoryData.tenancyLaw.icon} sx={serviceWorldNewCaseStyle.icon} alt={"Mietrecht"} />
              </Grid>
              <Grid>Beratung / Vertretung Mietrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Allgemeines Zivilrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={productCategoryData.civilLaw.icon} sx={serviceWorldNewCaseStyle.icon} alt={"Allgemeines Zivilrecht"} />
              </Grid>
              <Grid>Beratung / Vertretung Zivilrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
          <ListItem sx={serviceWorldNewCaseStyle.productCategoryHeadline}>Beamtenrecht</ListItem>
          <ListItemButton sx={serviceWorldNewCaseStyle.productItem} onClick={() => setLegalExpenseInsuranceModalOpen(true)}>
            <Grid
              container
              spacing={3}
              wrap={"nowrap"}
              sx={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Grid>
                <IconWrapper icon={productCategoryData.administrativeLaw.icon} sx={serviceWorldNewCaseStyle.icon} alt={"Beamtenrecht"} />
              </Grid>
              <Grid>Beratung / Vertretung Beamtenrecht</Grid>
              <Grid sx={serviceWorldNewCaseStyle.infoIcon}>
                <InfoOutlined />
              </Grid>
            </Grid>
          </ListItemButton>
        </List>
      </ServiceWorldContentBox>
      <DialogModal
        open={legalExpenseInsuranceModalOpen}
        onClose={() => setLegalExpenseInsuranceModalOpen(false)}
        title={"Prüfung Ihrer Rechtschutzversicherung erforderlich"}
      >
        <Box sx={serviceWorldNewCaseStyle.modalContent}>
          Dieser Service kann erst genutzt werden, wenn bereits eine <strong>Deckungszusage Ihrer Rechtsschutzversicherung</strong> vorliegt. Aktuell
          unterstützen wir in diesem Rechtsbereich nur bestimmte Versicherungspartner. Schreiben Sie uns unter{" "}
          <a href={"mailto:service@legalbird.de"}>service@legalbird.de</a>, und wir klären, ob Ihre Versicherung dazu gehört!
        </Box>
      </DialogModal>
    </Box>
  );
};

export default ServiceWorldNewCase;
